import { postData } from '@/services/api.service';
import { fetchCroppedImage } from '@/utils/constants';
import { ColorPicker } from 'primereact/colorpicker';
import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import ImageCropper from '@/components/imageCropper/imageCropper';
import { easyToImg, trustimg1 } from '@/utils/imagepath';
import { ImageType } from '@/services/openai.service';
import { RootState } from '@/core/redux/store';
import { useSelector, useDispatch } from 'react-redux';
import { setTemplateImages } from '@/core/redux/commonSlice';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
const TrustEditModal = ({ themeData, getThemeData }: any) => {
  const [checklist, setChecklist] = useState<any>([{ id: 1, title: '' }]);
  const [editData, setEditData] = useState<any>();
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);
  const [activeTab, setActiveTab] = useState(0);
  const [images, setImages] = useState<Array<string>>([]);


  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const addCollection = () => {
    let updatedCollection: any = [
      ...editData.theme_1.home.section_3.check_list,
    ];

    let newCard = {
      list: '',
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,

      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_3: {
            ...prevJsonData.theme_1.home.section_3,
            check_list: updatedCollection,
          },
        },
      },
    }));
  };

  const removeCollection = (index: any) => {
    let updatedCollection: any = [
      ...editData.theme_1.home.section_3.check_list,
    ];
    
    // Prevent deleting the last item
    if (updatedCollection.length <= 1) {
      toast.error('At least one check list item is required');
      return;
    }
    
    updatedCollection.splice(index, 1);
    
    // Adjust activeTab if necessary
    if (activeTab >= updatedCollection.length) {
      setActiveTab(updatedCollection.length - 1);
    } else if (activeTab > 0) {
      setActiveTab(activeTab - 1);
    }
    
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,

        home: {
          ...prevJsonData.theme_1.home,
          section_3: {
            ...prevJsonData.theme_1.home.section_3,
            check_list: updatedCollection,
          },
        },
      },
    }));
  };

  const handleHeaderChange = (e: any, index?: any) => {
    const { value, name } = e.target;

    let updatedCollection: any = [
      ...editData.theme_1.home.section_3.check_list,
    ];
    if (index !== undefined) {
      updatedCollection = [...editData.theme_1.home.section_3.check_list];
      updatedCollection[index] = {
        ...updatedCollection[index],
        [name]: value,
      };
    }

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_3: {
            ...prevJsonData.theme_1.home.section_3,
            [name]: value,
            btn_group: {
              ...prevJsonData.theme_1.home.section_3.btn_group,
              btn1: {
                ...prevJsonData.theme_1.home.section_3.btn_group.btn1,
                [name]: value,
              },
            },
            check_list: updatedCollection,
          },
        },
      },
    }));
  };

  const handleImageChange = (image: string) => {
    //Update the banner value in the JSON data
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_3: {
            ...prevJsonData.theme_1.home.section_3,
            banner: image,
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink);
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  useEffect(() => {
    const checklistData = editData?.theme_1?.home?.section_3?.check_list;
    if (checklistData) {
      setChecklist(checklistData);
    }
  }, [editData]);

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Load existing template images from Redux store
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      // Get the current template (template1, template2, etc.)
      const templateKey = template ? `template${template}` : 'template1';
      
      // Extract images for the current template
      const currentTemplate = templateImages[templateKey];
      const trustImages = currentTemplate?.image || [];
      
      if (Array.isArray(trustImages) && trustImages.length > 0) {
        // Filter images by resolution - for trust section, show square or near-square resolutions
        const filteredImages = trustImages.filter((img: any) => {
          if (!img.resolution) return true; // Include images without resolution info
          
          const [width, height] = img.resolution.split('x').map(Number);
          const aspectRatio = width / height;
          
          // Filter for square/icon images (aspect ratio between 0.9 and 1.1, typically 1024x1024, 512x512, etc.)
          return aspectRatio >= 0.9 && aspectRatio <= 1.1;
        });
        
        // Extract URLs from the filtered image objects
        const imageUrls = filteredImages.map((img: any) => img.url);
        setImages(imageUrls);
      } else {
        setImages([]);
      }
    } else {
      setImages([]);
    }
  }, [templateImages, template]);

  // Auto-generate prompt based on trust section context
  const generateAutoPrompt = (): string => {
    // Get context from the current trust section data
    const title = editData?.theme_1?.home?.section_3?.title || '';
    const subHeading = editData?.theme_1?.home?.section_3?.sub_heading || '';
    const paragraph = editData?.theme_1?.home?.section_3?.paragraph || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional icon or image for website trust section';
    
    if (title || subHeading || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        // Extract keywords from paragraph
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add trust/icon-specific styling
    contextPrompt += ', clean modern aesthetic, professional design, suitable for trust badge or icon, vibrant colors, high quality, clean background, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI image save
  const handleAIImageSave = (imageUrl: string) => {
    // Set the banner image
    handleImageChange(imageUrl);
    
    // Add to images array for slider
    setImages(prevImages => [...prevImages, imageUrl]);
  };

  return (
    <>
      {/* <Draggable> */}
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section Three Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Title</label>
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        name="title"
                        value={editData?.theme_1?.home?.section_3?.title}
                        onChange={handleHeaderChange}
                        maxLength={1200}
                      />
                    </div>
                  </div>
                </div>
                <div className="col-auto">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h2color"
                        value={editData?.theme_1?.home?.section_3?.h2color}
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="h2color"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={editData?.theme_1?.home?.section_3?.h2color}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Paragraph
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleHeaderChange({
                            target: {
                              name: 'paragraph',
                              value: content,
                            },
                          });
                        }}
                        contentType="website_description"
                        placeholder="Describe what you want in your paragraph. Example: 'Write about our trusted service, certifications, and customer satisfaction'"
                        context="This is for a trust/credibility section description"
                      />
                    </div>
                    <textarea
                      className="form-control"
                      name="paragraph"
                      value={editData?.theme_1?.home?.section_3?.paragraph}
                      onChange={handleHeaderChange}
                      maxLength={1200}
                      rows={3}
                    />
                  </div>
                </div>
                <div className="col-auto">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="paracolor"
                        value={editData?.theme_1?.home?.section_3?.paracolor}
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="paracolor"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={editData?.theme_1?.home?.section_3?.paracolor}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Sub Heading</label>
                    <input
                      type="text"
                      className="form-control"
                      name="sub_heading"
                      value={editData?.theme_1?.home?.section_3?.sub_heading}
                      onChange={handleHeaderChange}
                      maxLength={1200}
                    />
                  </div>
                </div>
                <div className="col-auto">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="h3color"
                        value={editData?.theme_1?.home?.section_3?.h3color}
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="h3color"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={editData?.theme_1?.home?.section_3?.h3color}
                      />
                    </div>
                  </div>
                </div>
              </div>
              <AIImageGenerator
                generateAutoPrompt={generateAutoPrompt}
                onSave={handleAIImageSave}
                imageType="image"
                defaultWidth="1024"
                defaultHeight="1024"
                title="AI Image"
                autoGenerate={true}
                template={template}
              />
              <div className="mb-3">
                <label className="form-label">Upload Image</label>
                <input
                  type="file"
                  accept="image/*"
                  className="form-control"
                  name="image"
                  onChange={updateImageSectionOne}
                />
              </div>
              <div className="row">
                <div className="">
                  <div className="row">
                    <div className="col">
                      <div className="mb-3">
                        <div className="row">
                          <div className="col-md-12 p-0">
                            <div className="img-bg active">
                              <img
                                src={editData?.theme_1?.home?.section_3?.banner}
                                alt="Card Icon"
                                className="img-fluid"
                                style={{ width: '100%', height: 'auto', objectFit: 'contain' }}
                              />
                            </div>
                          </div>
                          <div className="img-options">
                            <div className="row">
                              <div className="col-md-12">
                                {images.length > 0 ? (
                                  <Swiper
                                    spaceBetween={15}
                                    navigation={true}
                                    modules={[Navigation]}
                                    breakpoints={{
                                      640: {
                                        slidesPerView: 1,
                                      },
                                      768: {
                                        slidesPerView: 4,
                                      },
                                      1024: {
                                        slidesPerView: 6,
                                      },
                                    }}
                                    className="homejson-slider"
                                  >
                                    {images.map((images: string, index: any) => {
                                      return (
                                        <>
                                          <SwiperSlide>
                                            <div
                                              className="img-option"
                                              key={index}
                                              onClick={() =>
                                                handleImageChange(images)
                                              }
                                              style={{ cursor: 'pointer', padding: '5px' }}
                                            >
                                              <img
                                                src={images}
                                                alt="Trust Icon"
                                                className="img-fluid rounded"
                                                style={{ width: '100%', height: 'auto', objectFit: 'cover', borderRadius: '4px' }}
                                              />
                                            </div>
                                          </SwiperSlide>
                                        </>
                                      );
                                    })}
                                  </Swiper>
                                ) : (
                                  <div className="empty-slider-state text-center py-4">
                                    <div className="empty-state-content">
                                      <i className="fas fa-images fa-3x text-muted mb-3"></i>
                                      <h6 className="text-muted mb-2">No Images Available</h6>
                                      <p className="text-muted small mb-3">
                                        Generate AI images or upload your own to see them here
                                      </p>
                                    </div>
                                  </div>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_1?.home?.section_3?.check_list.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option nav-option-wrapper">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Check List {index + 1}
                          </a>
                          <a
                            className="nav-option-close"
                            onClick={() => {
                              removeCollection(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_1?.home?.section_3?.check_list.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      <div className="mb-3 mt-2">
                        <label className="form-label">
                          Check List<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="list"
                          value={card.list}
                          onChange={(e) => handleHeaderChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="add-section">
              <div className="row">
                <div
                  onClick={() => {
                    addCollection();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Button</label>
                    <input
                      type="text"
                      className="form-control"
                      name="text"
                      value={
                        editData?.theme_1?.home?.section_3?.btn_group?.btn1
                          ?.text
                      }
                      onChange={handleHeaderChange}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Bg Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="bg_color"
                        value={
                          editData?.theme_1?.home?.section_3?.btn_group?.btn1
                            ?.bg_color
                        }
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="bg_color"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={
                          editData?.theme_1?.home?.section_3?.btn_group?.btn1
                            ?.bg_color
                        }
                      />
                    </div>
                  </div>
                </div>
                <div className="col">
                  <div className=" mb-3">
                    <label className="form-label">Color</label>
                    <div className="input-group color-change">
                      <input
                        type="text"
                        className="form-control"
                        name="color"
                        value={
                          editData?.theme_1?.home?.section_3?.btn_group?.btn1
                            ?.color
                        }
                        onChange={handleHeaderChange}
                      />
                      <ColorPicker
                        name="color"
                        format="hex"
                        onChange={handleHeaderChange}
                        value={
                          editData?.theme_1?.home?.section_3?.btn_group?.btn1
                            ?.color
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {/* </Draggable> */}
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default TrustEditModal;
